/** The `map` area: the map and the Map page. Owned by the stage 2 slot views
 *  (docs/I18N.md §11). */
export const map = {
  // --- The Map page ------------------------------------------------------------
  'map.page.title': 'Map',
  'map.page.count': { one: '{count} item', other: '{count} items' },

  // --- The canvas and its altitude cluster -------------------------------------
  'map.canvas.layingOut': 'Laying out the network…',
  'map.canvas.label': 'Work network map. Arrow keys pan, plus and minus zoom, 0 fits to view.',
  'map.canvas.depth': 'Depth',
  'map.canvas.foldLevel': 'Fold one level',
  'map.canvas.unfoldLevel': 'Unfold one level',
  /** The depth control's value when nothing is folded. */
  'map.canvas.depthAll': 'All',
  'map.canvas.auto': 'Auto',
  'map.canvas.autoTitle': 'Let zoom drive the depth again',
  'map.canvas.zoomIn': 'Zoom in',
  'map.canvas.zoomOut': 'Zoom out',
  'map.canvas.fit': 'Fit to view',
  'map.canvas.reset': 'Reset view',
  'map.canvas.empty': 'No items match these filters.',

  // --- A node --------------------------------------------------------------------
  'map.node.selected': '{title}, selected',
  /** The requester seat on a card: who asked for the work. */
  'map.node.needs': 'Requested by {name}',
  'map.node.noRequester': 'no requester',
  /** The fold-out's line for an item granted to no group. */
  'map.node.noGroups': 'in no group',
  /** A group whose name the viewer cannot see. */
  'map.node.group': 'Group',
  /** The groups past the ones a card lists. */
  'map.node.more': '+{count} more',
  'map.node.expand': 'Expand card',
  'map.node.collapse': 'Collapse card',
  'map.node.fold': 'Fold this subtree',
  'map.node.unfold': {
    one: 'Unfold {count} hidden item',
    other: 'Unfold {count} hidden items',
  },
  'map.node.unfoldDeadlock': {
    one: 'Unfold {count} hidden item, including a deadlock',
    other: 'Unfold {count} hidden items, including a deadlock',
  },
  'map.deadlock': 'deadlock',

  // --- How items relate ---------------------------------------------------------
  'map.relation.partOf': 'Part of',
  'map.relation.contains': 'Contains',
  /** The edge kinds, as the legend and the phone's ladder name them. */
  'map.edge.partOf': 'part of',
  'map.edge.dependsOn': 'depends on',
  'map.edge.relatesTo': 'relates to',
  'map.edge.arrowheads': 'arrowheads',

  // --- The inspector -------------------------------------------------------------
  'map.inspector.doing': 'Contributor',
  'map.inspector.needsDoing': 'needs doing',
  'map.inspector.needs': 'Requested by',
  /** Nobody holds the requester seat. */
  'map.inspector.nobody': 'none',
  /** The groups an item is granted to, its own grants and those it inherits. */
  'map.inspector.groups': 'Groups',
  'map.inspector.partiesOnly': 'parties only',
  'map.inspector.containsCount': { one: '{count} item', other: '{count} items' },
  'map.inspector.waitingOn': 'Waiting on',
  'map.inspector.blocking': 'Blocking',
  'map.inspector.hint': 'Click to open',

  // --- A node's menu and the selection bar ----------------------------------------
  'map.menu.label': 'Actions for {title}',
  'map.menu.open': 'Open',
  'map.menu.scopeSubtree': 'Scope: subtree',
  'map.menu.scopeConnected': 'Scope: connected',
  'map.hide': 'Hide',
  'map.selection.label': 'Selection actions',
  'map.selection.count': '{count} selected',
  'map.selection.clear': 'Clear selection',

  // --- The phone map -------------------------------------------------------------
  'map.mobile.empty': 'Nothing to map yet.',
  'map.mobile.focused': 'Focused item',
  'map.mobile.connections': 'Connections',
  'map.mobile.open': 'Open {title}',
  'map.mobile.contains': 'contains {count}',
  'map.mobile.deadlockWith': 'deadlock with',
  'map.mobile.blockedBy': 'blocked by',
  'map.mobile.blocks': 'blocks',
} as const;
